import { openPtnrV2 } from 'conf/gconf';
import { langutil } from 'language/langutil';
import svcs from 'services';

export const countrylang = (url?: string) => {
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  return `/${country}/${lang}${url}`;
};

export const getLsPartnerLink = () => {
  if (openPtnrV2) {
    return countrylang('/community/partner-v2');
  }
  return countrylang('/community/partner');
};
